import { Injectable } from '@angular/core';
import {Http, RequestOptionsArgs, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {deserialize} from 'json-typescript-mapper';

@Injectable()
export class OsmNominatimService {

  nominatimUrl = 'https://nominatim.openstreetmap.org/';

  constructor(private http: Http) {}

  reverseGeocoding(format = 'jsonv2', lat: number, lon: number): Observable<any> {
    const options: RequestOptionsArgs = {
      params: {
        format: format,
        lat: lat,
        lon: lon
      }
    };
    return this.http.get(this.nominatimUrl + 'reverse', options).map(function(res: Response) {
      const body = res.json();
      return body;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/osm-nominatim.service.ts